import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      redirect: "/index"
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/components/home/index'],resolve),
      meta:{title:'首页'}
    },
    {
      path: '/curriculum',
      name: 'curriculum',
      component: resolve => require(['@/components/curriculum/index'],resolve),
      meta:{title:'知识体系'}
    },
    {
      path: '/newdetail',
      name: 'newdetail',
      component: resolve => require(['@/components/newdetail/index'],resolve),
      meta:{title:'新闻详情'}
    },
    {
      path: '/signup',
      name: 'signup',
      component: resolve => require(['@/components/signup/index'],resolve),
      meta:{title:'报名入口'}
    },
    {
      path: '/contact',
      name: 'contact',
      component: resolve => require(['@/components/contact/index'],resolve),
      meta:{title:'联系我们'}
    },
    {
      path: '/certificate',
      name: 'certificate',
      component: resolve => require(['@/components/certificate/index'],resolve),
      meta:{title:'证书介绍'}
    },
    {
      path: '/onLine',
      name: 'onLine',
      component: resolve => require(['@/components/onLine/index'],resolve),
      meta:{title:'在线系统'}
    },
    {
      path: '/mechanism',
      name: 'mechanism',
      component: resolve => require(['@/components/mechanism/index'],resolve),
      meta:{title:'机构介绍'}
    },
    {
      path: '/authInst',
      name: 'authInst',
      component: resolve => require(['@/components/signup/jump'],resolve),
      meta:{title:'授权机构'}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js